import React, { Fragment } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import UserLocationModal from "./UserLocationModal";

const selectStyle = {
  marginBottom: "0px",
};

const Actions = ({ edit, loading, allowDelete, onToggle, onDelete, onSave }) => {
  return (
    edit ? [
      <button key='save' className='btn btn-text' disabled={loading} onClick={onSave}>
        SAVE
      </button>,
      <button key='cancel' className='btn btn-text' disabled={loading} onClick={onToggle}>
        CANCEL
      </button>
    ] : [
      <button key='edit' className='btn btn-text' disabled={loading} onClick={onToggle}>
        EDIT
      </button>,
      <button key='delete' className='btn btn-text' disabled={!allowDelete} onClick={allowDelete ? onDelete : null}>
        REMOVE
      </button>
    ]
  )
}

const Primary = ({ state, edit, loading, onChange }) => {
  return (
    edit ? (
      <select className='form-control' title="Select Primary" style={selectStyle} disabled={loading} defaultValue={state} onChange={onChange}>
        <option value={true}>Y</option>
        <option value={false}>N</option>
      </select>
    ) : (
      <div>{ state ? 'Y' : 'N' }</div>
    )
  )
}

const LocationName = ({ locations, location, locationId, edit, loading, onChange }) => {
  return (
    edit ? (
      <select className='form-control' title="Select Location" style={selectStyle} disabled={loading} defaultValue={locationId || ''} onChange={onChange}>
        <option value=''>Select Location</option>
        {locations.map((location) => (
          <option key={location.id} value={location.id}>{location.name}</option>
        ))}
      </select>
    ) : (
      <span>
        {location.name}
        {location.active ? '' : <span className='pink-text'> (Inactive)</span>}
      </span>
    )
  )
}

class Location extends React.Component {
  state = {
    edit: this.props.data.id === null,
    loading: false,
    locationId: this.props.data.locationId,
    primary: this.props.data.primary,
    priority: this.props.data.priority,
    modalTitle: "",
    locationName: "",
    showModal: false, 
  };

  handleModalConfirm = (selectedOption, title) => {
    this.setState({ showModal: false });
    if(title === "Remove Location"){   
      this.handlerDelete(null, selectedOption);
      $("#userLocationModal").modal("hide");
    } else if(title === "Change Location") {
      this.handlerSave(null, selectedOption);
      $("#userLocationModal").modal("hide");
    }
  };

  componentDidUpdate(_, prevState) {
    if (this.state.showModal && !prevState.showModal) {
      $("#userLocationModal").modal("show");
      
      // Listen for the modal close event to reset showModal
      $("#userLocationModal").on("hidden.bs.modal", () => {
        this.setState({ showModal: false });
      });
    }
  }

  render() {
    const { provided, snapshot, data, allLocations, addedIds, allowDelete, futureShiftCountByLocation, futureShiftActionOptions } =
      this.props;
    const { edit, loading, modalTitle, locationName, showModal } = this.state;
    const locations = allLocations.filter(
      (location) =>
        (!addedIds.includes(location.id) && location.active === true) ||
        location.id === this.state.locationId
    );

    return (
      <Fragment>
        <tr
          ref={provided.innerRef}
          className={classNames("draggable-row", {
            "is-dragging": snapshot.isDragging,
          })}
          {...provided.draggableProps}
        >
          <td style={{ width: 30 }} {...provided.dragHandleProps}>
            {!edit && <h4 className="light-grey-text">☰</h4>}
          </td>
          <td style={{ width: 820 }}>
            <LocationName
              locations={locations}
              location={data}
              locationId={data.locationId}
              edit={edit}
              loading={loading}
              onChange={this.handlerChangeLocation}
            />
          </td>
          <td style={{ width: 80 }}>
            <Primary
              state={data.primary}
              edit={edit}
              loading={loading}
              onChange={this.handlerChangePrimary}
            />
          </td>
          <td style={{ width: 150 }} className="text-right">
            <Actions
              edit={edit}
              loading={loading}
              allowDelete={allowDelete}
              onToggle={this.handlerToggle}
              onDelete={this.haveFutureShifts('remove') ? this.openRemoveLocationModal : this.handlerDelete}
              onSave={this.haveFutureShifts('update') ? this.openUpdateLocationModal : this.handlerSave}
            />
          </td>
        </tr>

        {showModal && (
          <UserLocationModal
            onConfirm={this.handleModalConfirm}
            futureShiftActionOptions={futureShiftActionOptions}
            futureShiftCount={futureShiftCountByLocation[this.props.data.locationId]}
            locationName={locationName}
            locationId ={this.props.data.locationId}
            title={modalTitle}
          />
        )}
     </Fragment>
    );
  }

  handlerChangeLocation = (e) => {
    const oldLocationId = this.state.locationId;
    const locationId = parseInt(e.target.value);
    this.setState({ locationId });
    this.props.onChange(locationId, oldLocationId);
  };

  handlerChangePrimary = (e) => this.setState({ primary: e.target.value });

  handlerToggle = () => {
    if (this.props.data.id) {
      this.setState((prevState) => {
        if (prevState.edit) {
          this.props.onChange(
            this.props.data.locationId,
            this.state.locationId
          );
          return { edit: false };
        } else return { edit: true };
      });
    } else {
      this.props.onChange(null, this.state.locationId);
      this.props.onRemove(this.props.data._id);
    }
  };

  handlerDelete = (_event, selectedOption) => {
    this.props.onChange(null, this.state.locationId);
    this.props.onDelete(this.props.data.id, selectedOption);
  };

  handlerSave = (_event, selectedOption) => {
    this.setState({ loading: true });
    
    const data = {
      future_shift_action: selectedOption,
      priority: this.state.priority,
      location_id: this.state.locationId,
      primary: this.state.primary,
    };

    if (this.props.data._id) {
      data._id = this.props.data._id;
    }

    this.props.onSave(this.props.data.id, data, (status) => {
      this.setState({ loading: false }, () => {
        if (status) {
          this.handlerToggle();
        }
      });
    });
  };

  haveFutureShifts = (action) => {
    if(action === 'update')
      return this.props.data.locationId !== this.state.locationId && this.props.futureShiftCountByLocation[this.props.data.locationId] > 0;
    else
      return this.props.futureShiftCountByLocation[this.props.data.locationId] > 0;
  }

  openUpdateLocationModal = () => {
    const oldLocation = this.props.allLocations.find(
      (location) => location.id === this.props.data.locationId
    ); 
    this.setState({ modalTitle: 'Change Location', locationName: oldLocation.name, showModal: true });  
  }

  openRemoveLocationModal = () => {
    const location = this.props.allLocations.find(
      (location) => location.id === this.props.data.locationId
    );
    this.setState({ modalTitle: 'Remove Location', locationName: location.name, showModal: true }); 
  }
}

Location.defaultProps = {
  provided: PropTypes.object,
  snapshot: PropTypes.object,
  data: PropTypes.object.isRequired,
  allLocations: PropTypes.array,
  addedIds: PropTypes.array,
  allowDelete: PropTypes.bool.isRequired,
  onDelete: PropTypes.func,
  onSave: PropTypes.func,
  onRemove: PropTypes.func,
  onChange: PropTypes.func,
  futureShiftCountByLocation: PropTypes.object.isRequired,
  futureShiftActionOptions: PropTypes.array.isRequired,
};

export default Location;
